import styled from 'styled-components'
import HotRadio from '@hotmart/space-lib/dist/components/form/radio'
import HotCheckbox from '@hotmart/space-lib/dist/components/checkbox'
import { ScreenSizes } from 'src/styles'

export const MigrationContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: var(--spacer-5);
  padding-right: var(--spacer-5);
  height: calc(100vh - 4.375rem - 5.125rem);

  @media (min-width: ${ScreenSizes.sm}) {
    margin-left: var(--spacer-12);
    margin-right: var(--spacer-12);
  }
`

MigrationContainer.displayName = 'MigrationContainer'

export const CommunityItem = styled.div`
  border-bottom: 1px solid var(--gray-300) !important;

  &:last-child {
    border-bottom: none !important;
  }
`

CommunityItem.displayName = 'CommunityItem'

export const MembershipItem = CommunityItem

MembershipItem.displayName = 'MembershipItem'

export const CustomImage = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: var(--border-radius);
`

CustomImage.displayName = 'CustomImage'

export const Radio = styled(HotRadio)<{ $isDarkMode: boolean }>`
  .hot-form__input:checked ~ .hot-form__label::before {
    background-color: ${(props) =>
      props.$isDarkMode ? 'var(--gray-100)' : 'var(--gray-900)'}!important;
  }

  .hot-form__input:hover ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--spacer-2) var(--gray-400) !important;
  }

  .hot-form__input:focus ~ .hot-form__label::before {
    box-shadow:
      0 0 0 var(--input-border-width) var(--gray-400),
      0 0 0 calc(var(--spacer-1) - var(--input-border-width)) var(--white),
      0 0 0 calc(var(--spacer-1) + var(--input-border-width)) var(--gray-900) !important;
  }

  .hot-form__input:active ~ .hot-form__label::before {
    background-color: var(--gray-600) !important;
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900) !important;
  }

  .hot-form__input:checked ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900);
  }

  .hot-form--radio .hot-form__label::after {
    width: 24px !important;
    height: 24px !important;
  }
`

Radio.displayName = 'Radio'

export const CommunityListWrapper = styled.div`
  position: relative;
  border: 1px solid var(--gray-300) !important;
  margin-bottom: var(--spacer-6);
`

CommunityListWrapper.displayName = 'CommunityListWrapper'

export const CommunityListContainer = styled.div`
  max-height: 28vh;
  overflow-y: auto;
  padding: 0;

  @media screen and (min-height: 1400px) {
    max-height: 30vh;
  }

  @media screen and (min-height: 1800px) {
    max-height: 33vh;
  }

  @media screen and (min-height: 2000px) {
    max-height: 40vh;
  }

  @media screen and (min-height: 2160px) {
    max-height: 44vh;
  }
`

CommunityListContainer.displayName = 'CommunityListContainer'

export const MembershipListContainer = CommunityListContainer

MembershipListContainer.displayName = 'MembershipListContainer'

export const MembershipListWrapper = CommunityListWrapper

MembershipListWrapper.displayName = 'MembershipListWrapper'

export const CustomCheckbox = styled(HotCheckbox)<{ $isDarkMode: boolean }>`
  .hot-form__input:checked ~ .hot-form__label::before {
    background-color: ${(props) =>
      props.$isDarkMode ? 'var(--gray-100)' : 'var(--gray-900)'} !important;
  }

  .hot-form__input:hover ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--spacer-2) var(--gray-400) !important;
  }

  .hot-form__input:focus ~ .hot-form__label::before {
    box-shadow:
      0 0 0 var(--input-border-width) var(--gray-400) !important,
      0 0 0 calc(var(--spacer-1) - var(--input-border-width)) var(--white) !important,
      0 0 0 calc(var(--spacer-1) + var(--input-border-width)) var(--gray-900) !important;
  }

  .hot-form__input:focus {
    background-color: ${(props) =>
      props.$isDarkMode ? 'var(--gray-100)' : 'var(--gray-900)'} !important;
    border: var(--input-border-width) solid
      ${(props) => (props.$isDarkMode ? 'var(--gray-100)' : 'var(--gray-900)')} !important;
  }

  .hot-form__input:active ~ .hot-form__label::before {
    background-color: var(--gray-600) !important;
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900) !important;
  }

  .hot-form__input:checked ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900) !important;
  }

  .hot-form--custom .hot-form__input:checked ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900) !important;
  }
`

CustomCheckbox.displayName = 'CustomCheckbox'
